import styled from 'styled-components';

export const Body = styled.div`
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  background-color: #f8f8f8;
  padding-bottom: 80px;
`;

export const Header = styled.div`
  position: sticky;
  top: 0;
  background-color: white;
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #E5E5E5;
  z-index: 10;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InquiryList = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const InquiryItem = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
  }
`;

export const InquiryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const InquiryTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`;

export const InquiryStatus = styled.div<{ answered: boolean }>`
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.answered ? '#1FBC70' : '#999'};
  background-color: ${props => props.answered ? '#E8F8F1' : '#F5F5F5'};
  padding: 4px 10px;
  border-radius: 12px;
  white-space: nowrap;
  margin-left: 8px;
`;

export const InquiryContent = styled.div`
  font-size: 14px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 8px;
  text-align: left;
  display: block;
  max-width: 100%;
`;

export const InquiryDate = styled.div`
  font-size: 12px;
  color: #999;
  text-align: left;
`;

export const CreateButton = styled.button`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 440px;
  width: calc(100% - 40px);
  height: 50px;
  background-color: #1FBC70;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0px 4px 12px rgba(31, 188, 112, 0.3);
  transition: all 0.2s;

  &:hover {
    background-color: #18a860;
  }
`;

export const EmptyMessage = styled.div`
  text-align: center;
  color: #999;
  padding: 60px 20px;
  font-size: 14px;
`;

export const NoticeSection = styled.div`
  padding: 20px;
  margin: 10px 20px 0;
  text-align: left;
  border-top: 1px solid #e5e5e5;
  padding-top: 30px;
`;

export const NoticeTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 20px;
  text-align: left;
`;

export const NoticeItem = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 12px;
  padding-left: 12px;
  position: relative;
  text-align: left;

  &::before {
    content: '·';
    position: absolute;
    left: 0;
    color: #666;
  }
`;

export const NoticeLink = styled.span`
  color: #1FBC70;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #18a860;
  }
`;
